module.exports = __webpack_public_path__ + "static/media/tableSolicitation.574d85b9.svg";